import React, { useState } from 'react';
import { ChevronDown, Search } from 'lucide-react';
import { faqs } from '../data/faqData';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState<string | null>(null);
  const categories = Array.from(new Set(faqs.map(faq => faq.category)));
  const filteredFaqs = faqs.filter(faq => {
    const matchesSearch = faq.question.toLowerCase().includes(searchQuery.toLowerCase()) || faq.answer.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = activeCategory ? faq.category === activeCategory : true;
    return matchesSearch && matchesCategory;
  });
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="container mx-auto px-4 py-12 max-w-3xl" data-id="element-548">
      <div className="text-center mb-12" data-id="element-549">
        <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-550">
          Veelgestelde Vragen
        </h1>
        <p className="text-gray-600 mb-8" data-id="element-551">
          Heb je een vraag? Kijk hieronder of je het antwoord kunt vinden.
        </p>

        <div className="max-w-md mx-auto relative" data-id="element-552">
          <input type="text" placeholder="Zoek een vraag..." className="w-full border border-gray-300 rounded-md py-3 pl-10 pr-4 focus:outline-none focus:ring-2 focus:ring-gray-300" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-553" />
          <Search className="absolute left-3 top-3.5 text-gray-400" size={18} data-id="element-554" />
        </div>
      </div>

      {/* Category filter tags */}
      <div className="flex flex-wrap gap-2 mb-6" data-id="element-555">
        <button onClick={() => setActiveCategory(null)} className={`px-3 py-1.5 rounded-full text-sm border transition-colors duration-150 focus:outline-none ${activeCategory === null ? 'bg-gray-800 text-white border-gray-800' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'}`} data-id="element-556">
          Alles
        </button>
        {categories.map(category => <button key={category} onClick={() => setActiveCategory(activeCategory === category ? null : category)} className={`px-3 py-1.5 rounded-full text-sm border transition-colors duration-150 focus:outline-none ${activeCategory === category ? 'bg-gray-800 text-white border-gray-800' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'}`} data-id="element-557">
            {category}
          </button>)}
      </div>

      <div className="space-y-4" data-id="element-558">
        {filteredFaqs.length > 0 ? filteredFaqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden" data-id="element-559">
                <button onClick={() => toggleFAQ(index)} className="w-full flex justify-between items-center p-5 text-left hover:bg-gray-50 transition-colors duration-150 focus:outline-none" data-id="element-560">
                  <span className="font-medium text-gray-900 pr-4" data-id="element-561">
                    {faq.question}
                  </span>
                  <ChevronDown size={20} className={`text-gray-400 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-562" />
                </button>

                {isOpen && <div className="px-5 pb-5 pt-0 text-gray-600 leading-relaxed border-t border-gray-100 mt-2 pt-4" data-id="element-563">
                    <span className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 block" data-id="element-564">
                      {faq.category}
                    </span>
                    {faq.answer}
                  </div>}
              </div>;
      }) : <div className="text-center py-8 text-gray-500" data-id="element-565">
            Geen vragen gevonden voor "{searchQuery}"
          </div>}
      </div>
    </div>;
}